module.exports = __webpack_public_path__ + "static/media/article01.40ca5812.png";